import { getFinalUrl } from '../../utils/url.utils';

export async function openTestSite(testUrl: string) {
  Object.assign(document.createElement('a'), {
    target: '_blank',
    rel: 'opener',
    href: await getFinalUrl(testUrl),
    // we need to use referrerPolicy="unsafe-url" so we can access the external_id on the document.referrer
    // with the client-script widget
    referrerPolicy: 'unsafe-url',
  }).click();
}

export async function checkRequiredReferrerParams() {
  const searchParams = new URLSearchParams(window.location.search);
  const isPreview = searchParams.get('is_preview') === '1';
  if (isPreview) {
    return searchParams.has('project_uuid');
  } else {
    return searchParams.has('project_uuid') && searchParams.has('participation_uuid');
  }
}
